import React, { useContext, useMemo } from 'react';
import { ClientContextValue, ClientProviderProps } from './types';

const ClientContext = React.createContext<ClientContextValue | undefined>(
  undefined,
);

export const ClientProvider: React.FC<ClientProviderProps> = ({
  children,
  clientIp,
}) => (
  <ClientContext.Provider value={useMemo(() => ({ clientIp }), [clientIp])}>
    {children}
  </ClientContext.Provider>
);

export function useClient() {
  const context = useContext(ClientContext);

  if (context === undefined) {
    throw new Error('useCient must be used within ClientProvider');
  }

  return context;
}
